











































import { Component, Vue } from 'vue-property-decorator';
import { ALL_CARS } from '@/queries/Car';
import CarEditButton from '@/components/Car/CarEditButton.vue';
import CarNewButton from '@/components/Car/CarNewButton.vue';
import CarShowButton from '@/components/Car/CarShowButton.vue';
import CarDeleteButton from '@/components/Car/CarDeleteButton.vue';
import PermissionService from '@/utils/permission-service';


@Component({
  components: {
    CarEditButton,
    CarNewButton,
    CarShowButton,
    CarDeleteButton,
  },
})
export default class CarList extends Vue {
  private ALL_CARS = ALL_CARS;
  private PermissionService = PermissionService;
}
